import { render, staticRenderFns } from "./baseModel.vue?vue&type=template&id=44447524&scoped=true"
import script from "./baseModel.vue?vue&type=script&lang=js"
export * from "./baseModel.vue?vue&type=script&lang=js"
import style0 from "./baseModel.vue?vue&type=style&index=0&id=44447524&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44447524",
  null
  
)

export default component.exports